import React, { useState, useEffect } from "react";

import styles from "./ContactsSelect.module.scss";
import { useDispatch } from "react-redux";
import { generalActions } from "../../store/actions";
import { useDebounce } from "../../views/scopeOverview/hooks/useDebounce";
import contactservice from "../../store/services/contact.service";
import { FilterCross,AddPersonIcon } from "../../modules/default-svg";
import {
    TeachingPopover,
    Avatar,
    Button,
    TeachingPopoverBody,
    TeachingPopoverHeader,
    TeachingPopoverSurface,
    TeachingPopoverTrigger
  } from "@fluentui/react-components";
import Input from "../../components/controls/input/customInput/CustomInput";
import Spin from "../../components/controls/spinner/Spin";
import CustomButton from "../../components/controls/button/Button";
import Phone from "../../components/controls/input/phoneInput/PhoneInput";
import { isValidEmail } from "../../utils/formValidation";
import { ArrowLeft } from "../../modules/default-svg";


export default function ContactsSelect({parentType, parentId, isNewParent = true, isMultiSelect = true, confirmHandler,submitNewContactHandler, existingSelectedContacts = []}) {
  const [openPopover, setIsPopoverOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);   
  const [isCreateLoading, setIsCreateLoading] = useState(false);   
  const [isCreate, setIsCreate] = useState(false);
  const emptyContact = {name:'',email:'',phone:'',notes:''};
  const [newContact, setNewContact] = useState(emptyContact); 
 const [newContactErrors, setNewContactErrors] = useState({});
  
  const dispatch = useDispatch();
  const addContactButtonLabel = isMultiSelect ? 'Add Contacts' : 'Add Contact';


  const filterContacts = (searchResults, exitingContactsList) => {
    const exitingContactsIdsList = exitingContactsList.map(
      (item) => item.id
    );
    const newSearchedContactsList = searchResults.filter(
      (item) => !exitingContactsIdsList.includes(item.id)
    );

    return newSearchedContactsList;
  };

  const searchContacts = useDebounce((searchTerm) => {
    setIsCreate(false);
    if(searchTerm == undefined)
        searchTerm = '';
      setIsLoading(true);
      contactservice
        .searchContacts(parentType, parentId, searchTerm)
        .then((searchResults) => {
          const newSearchedContactsList = filterContacts(searchResults, selectedContacts);
  
          const searchedContactsList = newSearchedContactsList.map(
            (contact) => ({ ...contact, isSelected: false})
          );
  
          setContacts(searchedContactsList);
          setIsLoading(false);
        })
        .catch(() => {
          setContacts([]);
          setIsLoading(false);
        });
    }, 500);


    // const handleClear = () => {
    //     setContacts([]);
    //     setSelectedContacts([]);
    //     setIsPopoverOpen(false);
    //     setNewContact(emptyContact);
    //   };

      const handleAddContact = (resource) => {
        setContacts((prev) => {return prev.filter((res) => res.id !== resource.id)});
        resource.isSelected = true;
        setSelectedContacts((prev) => {
            const updatedContacts = [...prev, resource];
            submitContacts(updatedContacts);
            return updatedContacts;
        });
      }

      const handleRemoveSelectedContact = (resource) => {
        resource.isSelected = false;
        setSelectedContacts((prev) => {
            const updatedContacts = prev.filter((res) => res.id !== resource.id);
            submitContacts(updatedContacts);
            return updatedContacts;
        });
        setContacts([...contacts, resource]);
      }

      const submitContacts = (contacts) => {
        confirmHandler(contacts.length > 0 ? contacts.map(contact => contact.id).join(",") : '');
        if(!isMultiSelect)
            setIsPopoverOpen(false);
      }
    const handleConfirm = () => {
        submitContacts(selectedContacts);
        setIsPopoverOpen(false);
    }

    const handleCreateContact = useDebounce(() => {

        if(ValidateNewContact()) return;
        setIsCreateLoading(true);
        if(isNewParent){
            setSelectedContacts((prev) => {
                const updatedContacts = [...prev, newContact];
                submitNewContactHandler(newContact);
                setIsCreateLoading(false);
                toggleCreateMode(false);
                if(!isMultiSelect)
                    setIsPopoverOpen(false);
                return updatedContacts;
            });
        }
        else{
            contactservice.createContact(parentType, parentId, newContact)
            .then(() => {
                setIsCreateLoading(false);
                dispatch(
                        generalActions.showToast({
                            title: "Contact created successfully",
                            type: "success",
                        })
                        );
                toggleCreateMode(false);
            })
            .catch(() => {
                setIsCreateLoading(false);
                dispatch(
                        generalActions.showToast({
                            title: "Something went wrong. Please try again later.",
                            type: "error",
                        })
                        );
            });
        }
        
    })
    
    const validateEmail = (e) => {
        setNewContactErrors((prevErrors) => ({
        ...prevErrors,
        Email: !isValidEmail(e.target.value)?"Invalid Email":"",
        }));
    };

    const handleContactEmailChange = (email) =>{
        setNewContact((contact) => ({ ...contact, email: email }))
        setNewContactErrors((prevErrors) => ({
          ...prevErrors,
          email: "",
        }));
      }

      const ValidateNewContact = () => {
          let errors = {};
        
          if (
            (!newContact.name || newContact.name.trim().length === 0) &&
            (!newContact.email || newContact.email.trim().length === 0) &&
            (!newContact.phone || newContact.phone.trim().length === 0)
        ) {
            errors.name = " ";
            errors.email = " ";
            errors.phone = " ";
          }
        
          if (newContact.email && newContact.email.trim().length > 0 && !isValidEmail(newContact.email)) {
            errors.email = "Invalid Email";
          }
    
        
          setNewContactErrors(errors);
          return Object?.keys(errors)?.length > 0;
        };
      
        const toggleCreateMode = (active) =>{
                setNewContact(emptyContact);
                setNewContactErrors({});
            if(active){
                setIsCreate(true);
            }
            
            else{
                setIsCreate(false);
                searchContacts();
            }
                
            
        }

     useEffect(() => {
        setContacts([]);
        setSelectedContacts(existingSelectedContacts?.length > 0 ? existingSelectedContacts :[]);
        setNewContactErrors({});
      }, []);

    return (
            <div className="mb-2">
              <div
                className={`AssignResBox ${
                  selectedContacts.length > 0
                    ? "assignToWrapper"
                    : "selectResource"
                }`}
              >
                <div className="assignToItems"               
                     style={{ 
                        display: !isMultiSelect && selectedContacts.length > 0 ? "none" : "",
                        backgroundColor: "#f5f5f5"}}>
                  <TeachingPopover
                    positioning="below-start"
                    withArrow={false}
                    open={openPopover}
                    onOpenChange={(event, data) => setIsPopoverOpen(data.open)}
                  >
                    <TeachingPopoverTrigger>
                    
                     {!isMultiSelect 
                        ? 
                            selectedContacts.length > 0 
                                ?
                                ''
                                :
                                <Button className="assignAvatarBtn" onClick={() => {searchContacts()}}>
                                    <Avatar icon={<AddPersonIcon />} name="" />
                                    <p className="text-xsm-400 ms-1 d-flex align-items-center">
                                        {addContactButtonLabel}
                                    </p>
                                </Button>
                        :
                        <Button className="assignAvatarBtn" onClick={() => {searchContacts()}}>
                            <Avatar icon={<AddPersonIcon />} name="" />
                            <p className="text-xsm-400 ms-1 d-flex align-items-center">
                                {addContactButtonLabel}
                            </p>
                        </Button>
                      }
                    </TeachingPopoverTrigger>
                    <TeachingPopoverSurface className="assignAvatarSurface">
                      <TeachingPopoverHeader
                        className="assignAvatarHeader"
                        icon={false}
                      >
                        {isCreate ?
                        <>
                        <div
                            className="d-flex align-items-center"
                            onClick={() => {toggleCreateMode(false)}}
                        >
                            <ArrowLeft />
                            <p className="my-3 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer">
                                Contacts
                            </p>
                        </div>
                        <p className="m-auto">New Contact</p>
                        </>
                        :
                        <p>Contacts</p>
                        
                        }
                        
                      </TeachingPopoverHeader>
                      <TeachingPopoverBody className="assignAvatarBody">
                        
                      {!isCreate ? (
                            <>
                                <Input placeholder="Search" handleChange={searchContacts} />
                                {isLoading ? (
                                    <div className="d-flex justify-content-center mt-4">
                                        <Spin />
                                    </div>
                                ) : contacts.length > 0 ? (
                                    <div className="mt-2 userChipWrapper">
    
                                        <div className="assignToItems">
                                            <Button 
                                                className="assignAvatarBtn"
                                                style={{border: "none"}}
                                                onClick={() => {toggleCreateMode(true)}}
                                                >
                                                                    <Avatar icon={<AddPersonIcon />} name="" />
                                                                    <p className="text-xsm-400 ms-1 d-flex align-items-center">
                                                                        Add New
                                                                    </p>
                                            </Button>
                                        </div>
                                        {contacts.map((res) => (
                                            <div
                                                key={res.id} // Always add a unique key when mapping lists
                                                className={`userChip cursor-pointer ${res.isSelected ? "active" : ""}`}
                                                onClick={() => handleAddContact(res)}
                                            >
                                                <Avatar color="colorful" name={res.name} image={{ src: "" }} />
                                                <p className="text-xsm-400">{res.name || res.email || res.phone}</p>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                <div className="h-full flex flex-col items-center justify-center p-8">
                                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.75 4A3.25 3.25 0 0 1 22 7.25v9.505a3.25 3.25 0 0 1-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.755V7.25a3.25 3.25 0 0 1 3.066-3.245L5.25 4h13.5Zm-9.497 8.5H5.75a.75.75 0 0 0-.743.648L5 13.25v.581c0 1.273.968 1.919 2.501 1.919 1.466 0 2.416-.59 2.496-1.755l.006-.163v-.582a.75.75 0 0 0-.649-.743l-.101-.007Zm2.997 0-1.416-.001c.086.182.142.381.161.591l.008.16v.582l-.01.254a2.85 2.85 0 0 1-.205.899c.108.01.22.015.337.015 1.052 0 1.793-.407 1.869-1.27l.006-.147v-.333a.75.75 0 0 0-.648-.743l-.102-.007-1.416-.001 1.416.001Zm6 0h-3l-.102.007a.75.75 0 0 0 0 1.486l.102.007h3l.102-.007a.75.75 0 0 0 0-1.486l-.102-.007ZM7.5 8.5a1.5 1.5 0 1 0 0 3.001 1.5 1.5 0 0 0 0-3.001Zm3.87.502a1.248 1.248 0 1 0 0 2.496 1.248 1.248 0 0 0 0-2.496Zm6.88.498h-3l-.102.007a.75.75 0 0 0 0 1.486l.102.007h3l.102-.007a.75.75 0 0 0 0-1.486L18.25 9.5Z" fill="#342C82"/></svg>
                                    <h3 className="text-sm font-semibold text-gray-800 mb-2">
                                        No contacts currently available
                                    </h3>
                                    <CustomButton
                                        btnClass="d_btn d_btn_primaryXsm"
                                        label="+ Add New"
                                        clickHandler={() =>{toggleCreateMode(true)}}
                                    />
                                </div>
                                )}
                            </>
                        ) : (
                            <div className="d-flex flex-column align-items-center gap-2">
                                    <div className="row w-100">
                                        <Input
                                            icon={false}
                                            value={newContact.name}
                                            type="text"
                                            errorMessage={newContactErrors["name"]}
                                            handleChange={(v) => {setNewContact((contact) => ({ ...contact, name: v }))}}
                                            label="Name"
                                        />
                                    </div>
                                    <div className="row w-100">
                                            <Input
                                                icon={false}
                                                value={newContact.email}
                                                errorMessage={newContactErrors["email"]}
                                                type="email"
                                                handleBlur={(e) => validateEmail(e)}
                                                handleChange={handleContactEmailChange}
                                                label="Email"
                                            />
                                        
                                    </div>
                                    <div className="row w-100">
                                        <Phone
                                            label="Phone Number"
                                            errorMessage={newContactErrors["phone"]}
                                            handleChange={(v) => {setNewContact((contact) => ({ ...contact, phone: v }))}}
                                            value={newContact.phone}
                                        />
                                    </div>
                                <div className="d-flex align-items-end gap-2 justify-content-end m-2">
                                <CustomButton
                                    btnClass="d_btn d_btn_white d_btn_whiteXsm"
                                    label="Cancel"
                                    clickHandler={() =>{toggleCreateMode(false)}}
                                />
                                <CustomButton
                                    btnClass="d_btn d_btn_primary d_btn_primaryXsm"
                                    label="Save"
                                    clickHandler={handleCreateContact}
                                    showLoading={isCreateLoading}
                                />
                                </div>
                            </div>
                        )}


                      </TeachingPopoverBody>
                      {!isCreate &&
                        <div className="assignAvatarFooter">
                            {/* <CustomButton
                                btnClass="d_btn d_btn_whiteXsm me-10"
                                label="Cancel"
                                clickHandler={handleClear}
                            /> */}
                            <CustomButton
                                btnClass="d_btn d_btn_primaryXsm"
                                label="Confirm"
                                clickHandler={handleConfirm}
                            />
                        </div>
                        }
                      
                    </TeachingPopoverSurface>
                  </TeachingPopover>
                </div>
                {selectedContacts.map((res) => (
                  <div className="assignToItems">
                    <Avatar
                      color="colorful"
                      name={res.name}
                      image={{ src: "" }}
                    />
                    <p className="text-xsm-400">{res.name || res.email || res.phone}</p>
                    <div onClick={() => handleRemoveSelectedContact(res)}>
                      <FilterCross />
                    </div>
                  </div>
                ))}
              </div>
            </div>
    );
  }